<template>
  <div class="zj-mobile-map map"></div>
</template>

<script>
import { Toast } from "mint-ui";

export default {
  name: "EmgMap",
  controller: "UI",
  action: "Map",
  props: {
    center: {
      type: Object,
      default: function () {
        return [0, 0];
      },
    },
    point: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      currentPoint: {},
    };
  },
  watch: {
    //监听中心点，绘制应急中心点
    center:{
      handler(val, oldVal) {
        this.center = val
        let that = this;
        var interval = setInterval(() => {
          if (that.mapInstance) {
            clearInterval(interval);
            this.addDom();
          }
        }, 1000);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    goCenter: function () {
      // eslint-disable-next-line no-undef
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
    },
    addDom: function () {
      if (!this.mapInstance) return;
      var layer = this.mapInstance.getLayerByName("DOM");
      if (layer && layer.addDom) {
        // eslint-disable-next-line no-undef
        var $div = $("<div></div>");
        $div.append(this.getSvgContent());
        $div.css({
          width: "3rem",
          height: "3rem",
          "margin-left": "-1.5rem",
          "margin-top": "-1.5rem",
          position: "absolute",
        });
        if (this.point.length > 0) {
          layer.addDom(this.point[0], this.point[1], $div[0]);
        } else {
          layer.addDom(this.center[0], this.center[1], $div[0]);
        }
      }
    },
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        // '  <div class="circle delay1"></div>' +
        // '  <div class="circle delay2"></div>' +
        // '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    getCurrentPostion() {
      let that = this;
      // eslint-disable-next-line no-undef
      var geolocation = new BMap.Geolocation();
      // eslint-disable-next-line no-undef
      //var gc = new BMap.Geocoder();//创建地理编码器
      // 开启SDK辅助定位

      geolocation.enableSDKLocation();

      geolocation.getCurrentPosition(function (r) {
        // eslint-disable-next-line no-undef
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          // eslint-disable-next-line no-undef
          var mk = new BMap.Marker(r.point);

          that.mapInstance.addOverlay(mk);

          //map.panTo(r.point);

          //Toast(JSON.stringify(r.point));
          //var pt = r.point;

          //map.panTo(pt);//移动地图中心点

          // gc.getLocation(pt, function(rs){
          // 	var addComp = rs.addressComponents;
          // 	 alert(addComp.province + addComp.city + addComp.district);
          // });
        } else {
          Toast("获取地理位置失败" + this.getStatus());
        }
      });
    },
  },
  mounted() {
    // 创建地图，并通过样式让地图填满窗口
    let that = this;

    this.$nextTick(function () {
      // eslint-disable-next-line no-undef
      $(function () {
        // 不传入 syscode 和 key ，或者值为空时，
        // zjumap 插件自动从 URL 地址
        // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
        // 中读取 syscode 和 key 的值。

        // eslint-disable-next-line no-undef
        $(".map").zjumap({
          syscode: "ZJMap",
          key: "EmergencyOneMap",
          //地图配置
          mapConfigs: {
            mapStyle: "",
            togglePanelVisiable: false,
            //tilesPath: "",
            clickToShowLocation: false,
            mapLayers: "DOM",
            onMapCreated: function (e) {
              that.mapInstance = e.map;
              // that.center = e.map.config.center;

              // setTimeout(() => {
              //   that.addDom();
              // }, 1000);

              // setTimeout(() => {
              //   that.getCurrentPostion();
              // }, 1000);
            },
          },
        });
      });
    });
  },
};
</script>